import { checkValueEmpty } from './checkValueEmpty';
const isObject = (candidate) => {
    return candidate !== null && typeof candidate === 'object' && !Array.isArray(candidate);
};
export const normalizeObject = (candidate) => {
    const result = Object.entries(candidate)
        .map(([k, v]) => [k, isObject(v) ? normalizeObject(v) : v])
        .filter(([, v]) => !checkValueEmpty(v));
    return Object.fromEntries(result);
};
